import Chip from '@mui/material/Chip';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { reimbursementStateLabelKey, type ReimbursementOutcome } from '../../reimbursement';

const OUTCOME_COLORS = {
    Requested: 'default',
    Approved: 'success',
    Declined: 'error',
} as const satisfies Record<ReimbursementOutcome, 'default' | 'success' | 'error'>;

export type ReimbursementStatusChipProps = {
    outcome: ReimbursementOutcome;
    reimbursedCredits?: number;
};

export function ReimbursementStatusChip({ outcome, reimbursedCredits }: ReimbursementStatusChipProps): ReactElement {
    const { t } = useTranslation();

    // An approved request states what came back rather than that it was approved — the two together
    // do not fit on a card.
    const label =
        outcome === 'Approved' && reimbursedCredits !== undefined
            ? t('REIMBURSEMENT.CREDITS_REIMBURSED', { count: reimbursedCredits })
            : t(reimbursementStateLabelKey(outcome));

    return <Chip size="small" color={OUTCOME_COLORS[outcome]} variant="outlined" label={label} />;
}
